<template>
  <div class="player-controls" :class="classes">
    <transition name="fade-transition" appear>
      <div key="controls" v-show="!disabled" class="player-controls__wrap">
        <PlayerControlItem
          v-bind="buttons.play"
          @click.prevent="togglePlay"
          :disabled="sending"
        />
        <PlayerControlItem
          v-if="buttons.record"
          v-bind="buttons.record"
          @click.prevent="record"
          :disabled="sending"
        />
        <PlayerControlItem
          v-if="buttons.send"
          v-bind="buttons.send"
          @click.prevent="send"
          :loading="sending"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import PlayerControlItem from "./PlayerControlItem";
import { requestAlert, showAlert } from "@/services/common/showAlert";
// import uniq from "lodash/uniq";
// import flatMap from "lodash/flatMap";

const ButtonsData = {
  play: { text: "Смотреть видео", icon: "play", color: "yellow-grad" },
  listen: { text: "Воспроизвести запись", icon: "play", color: "yellow-grad" },
  rerecord: {
    text: "Записать еще&nbsp;раз",
    icon: "microphone-refresh",
    color: "red-grad"
  },
  record: { text: "Начать запись", icon: "microphone", color: "red-grad" },
  send: {
    text: "Сохранить и&nbsp;отправить",
    icon: "send",
    color: "yellow-grad"
  }
};

export default {
  name: "PlayerControls",
  components: { PlayerControlItem },
  inject: ["playerInstance"],

  props: {
    disabled: Boolean,
    noOverlay: Boolean
  },

  data: () => ({
    sending: false
  }),

  computed: {
    classes() {
      return {
        "show-overlay": !this.noOverlay
      };
    },

    canRecord() {
      return !this.playerInstance.audio;
    },

    isRecorded() {
      return this.playerInstance.statuses.recorded;
    },

    playBtnType() {
      return !this.canRecord || this.isRecorded ? "listen" : "play";
    },

    recordBtnType() {
      return this.isRecorded ? "rerecord" : "record";
    },

    buttons() {
      return {
        play: ButtonsData[this.playBtnType],
        record: (this.canRecord && ButtonsData[this.recordBtnType]) || false,
        send: (this.canRecord && this.isRecorded && ButtonsData.send) || false
      };
    }
  },

  methods: {
    togglePlay() {
      if (this.playerInstance.statuses.playing) {
        this.pause();
      } else {
        this.play();
      }
    },
    play() {
      if (this.playerInstance) this.playerInstance.play();
    },

    pause() {
      if (this.playerInstance) this.playerInstance.pause();
    },

    record() {
      if (this.playerInstance) this.playerInstance.record();
    },

    async send() {
      if (!this.playerInstance || this.sending) return;
      this.sending = true;
      this.playerInstance.setClosableModal(false);

      try {
        const { success, message, data } = await this.playerInstance.upload();
        if (success) {
          await showAlert(message, 0, true, "OK", "center");
          this.$modals.close();
        } else {
          await requestAlert(message || undefined, data || []);
        }
      } catch (e) {
        await requestAlert();
        console.error(e);
      } finally {
        this.playerInstance.setClosableModal();
        this.sending = false;
      }
    }
  }
};
</script>

<style lang="scss">
.player-controls {
  @include make-row(0);
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 5;
  transition: background-color $primary-transition;

  &.show-overlay {
    pointer-events: all;
    background-color: rgba(#000, 0.8);
  }

  &__wrap {
    @include make-row(0);
    pointer-events: none;
    justify-content: center;
    flex-basis: 80%;

    @include breakpoint("xs-only") {
      flex-basis: 90%;
    }
  }

  &__item {
    @include make-col-ready;
    @include make-col(1, 3);
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__text {
    line-height: 1.47;
    margin-top: 15px;
    text-align: center;

    br {
      display: none;
    }
  }

  &__btn {
    width: 80px;
    height: 80px;
    pointer-events: all;

    .btn__content {
      flex: 0 0 65%;
      max-width: 65%;
      width: 100%;
      height: 100%;
    }

    svg {
      width: 100%;
      height: auto;
    }
  }

  @include breakpoint("xs-only") {
    &__btn {
      width: 50px;
      height: 50px;
      padding: 0 !important;
      .btn__content {
        flex: 0 0 45%;
        max-width: 45%;
      }
    }

    &__text {
      font-size: 10px;
      margin-top: 5px;
    }
  }
}
</style>
